<script lang="ts">
  import type { Snippet } from "svelte"
  import ActionBox from "@kontextwerk/web-sdk/ui/layout/ActionBox.svelte"

  type TagColor = "blue" | "red" | "neutral" | "green" | "teal" | "yellow" | "orange" | "purple"

  type Props = {
    label: string
    tag?: string
    tagColor?: TagColor
    children?: Snippet | null
    actions?: Snippet | null
  }

  const { label, tag = "", tagColor = "red", children = null, actions = null }: Props = $props()
</script>

<ActionBox {label} {tag} {tagColor} darkMode={false} buttonSnippet={actions ? actionSnippet : null}>
  <div class="create-workflow-action-box">
    {@render children?.()}
  </div>
</ActionBox>

{#snippet actionSnippet()}
  <div class="create-workflow-actions">
    {@render actions?.()}
  </div>
{/snippet}

<style>
  .create-workflow-action-box {
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
    padding-top: 0.15rem;
    color: var(--text-100);
  }

  .create-workflow-action-box :global(p) {
    margin: 0;
    color: color-mix(in srgb, var(--text-100) 76%, transparent);
    line-height: 1.45;
  }

  .create-workflow-action-box :global(.create-workflow-field-grid) {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(14rem, 1fr));
    gap: 1rem;
  }

  .create-workflow-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 0.5rem;
  }
</style>
